import React, { useState, useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import FuturesPageHeader from '../../pages/markets/pages/futures/header';
import JoinOfficialChannels from '../../collection-templates/join-official-channels';
import ResearchReportsAlternate from '../../pages/markets/component/research-reports-alternate';
import MarketsNewsFutures from '../../pages/markets/component/markets-news-futures';
import OpenInterestFutures from '../../pages/markets/component/open-interest-futures';
import GreatestPremiumDiscountFutures from '../../pages/markets/component/greatest-premium-discount-futures';
import RolloverFutures from '../../pages/markets/component/rollover-futures';
import AccumulationTableFutures from '../../pages/markets/component/accumulation-table-futures';
import MostActiveTableFutures from '../../pages/markets/component/most-active-table-futures';
import FuturesAndOptionsFaq from '../../pages/markets/component/futures-and-options-faq';
import SectoralMovementsFutures from '../../pages/markets/component/sectoral-movements-futures';
import FuturesGraphWidget from '../../pages/markets/component/futures-graph-widget';
import { WithLazy } from '@quintype/components';
import { useSelector } from "react-redux";
import get from "lodash/get";
import '../../pages/markets/pages/futures/futures.m.css';

const FuturesContractFull = (props) => {
  const [marketNews, setMarketNews] = useState({});
  const queryClient = new QueryClient();
  const [isLoading, setIsLoading] = useState(false);
  const NDTV_SEARCH_API_CONFIG = useSelector((state) =>
    get(state, ['qt', 'config', 'integrations', 'aiSummary'], {}),
  );

  useEffect(() => {
    const getMarketNews = async () => {
      setIsLoading(true);
      const response = await fetch(`${NDTV_SEARCH_API_CONFIG?.url}${NDTV_SEARCH_API_CONFIG?.client_key}${NDTV_SEARCH_API_CONFIG?.story_params}&pagesize=10&${NDTV_SEARCH_API_CONFIG?.markets_param}`);
      const data = await response.json();
      setMarketNews(data?.results || []);
      setIsLoading(false);
    };
    getMarketNews();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <>
        <div styleName="background-container gap-adjustments">
          <div className="container">
            <FuturesPageHeader {...props} />
          </div>
          <div styleName="container-gap-top-alt container-gap-bottom" className="container">
            <FuturesGraphWidget widget={true} />
          </div>
        </div>
        <WithLazy>
          {() => (
            <div styleName="minor-major-fold gap-adjustments" className="container">
              <OpenInterestFutures widget={true} />
              <MarketsNewsFutures newsData={marketNews} loadingStatus={isLoading} widget={true} />
            </div>
          )}
        </WithLazy>
        <WithLazy>
          {() => (
            <div styleName="three-grid-fold gap-adjustments" className="container">
              <GreatestPremiumDiscountFutures widget={true} />
              <RolloverFutures widget={true} />
            </div>
          )}
        </WithLazy>

        <WithLazy>
          {() => (
            <div styleName="major-minor-fold gap-adjustments" className="container">
              <ResearchReportsAlternate widget={true} />
              {!props?.widget && (
                <div>
                  <JoinOfficialChannels sectionName="futures-contract-full-widget" />
                </div>
              )}
            </div>
          )}
        </WithLazy>
        <WithLazy>
          {() => (
            <div styleName="background-container">
              <div styleName="gap-adjustments container-gap-top" className="container">
                <AccumulationTableFutures limit={10} external={true} widget={true} />
              </div>

              <div styleName="gap-adjustments " className="container">
                <MostActiveTableFutures limit={10} external={true} widget={true} />
              </div>

              <div styleName="gap-adjustments " className="container">
                <SectoralMovementsFutures widget={true} />
              </div>

              <div styleName="gap-adjustments  container-gap-bottom" className="container">
                <FuturesAndOptionsFaq widget={true} />
              </div>
            </div>
          )}
        </WithLazy>
      </>
    </QueryClientProvider>
  );
};

export default FuturesContractFull;
